import { patchTech } from "../../../api/tech/patchTech";
import { validateRequiredKeys } from "../../../Common/formUtils";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";

import { RegistrationEducationFormType } from "./RegistrationEducationFormContext";

export const validate = (form: RegistrationEducationFormType) => {
  const requiredKeys: (keyof RegistrationEducationFormType)[] = ["school", "yearsOfPractice"];
  const errors = validateRequiredKeys({ form, requiredKeys });
  return errors;
};

export const useSave = () => {
  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const { redirectToHireflix } = useRedirect();

  const save = async (form: RegistrationEducationFormType): Promise<void> => {
    setRegistrationContext({
      registrationContext: {
        ...registrationContext,
        ...form,
      },
    });

    await patchTech({
      userId: registrationContext.userId,
      techId: registrationContext.entityId,
      ...form,
    });

    EventTracker.send({
      eventName: Event.Name.TECH_CLICK_EDUCATION,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.TECH,
      entityId: registrationContext.entityId,
    });

    redirectToHireflix();
  };

  return { save };
};
